document.addEventListener('DOMContentLoaded', () => {
    const autoplayElements = document.querySelectorAll('.js-autoplayElement');

    autoplayElements.forEach(container => {
        const items = container.querySelectorAll('.js-autoplayItem');
        const images = container.querySelectorAll('.js-autoplayImage');
        const pauseBtn = container.querySelector('.js-autoplayPause');
        const pauseIcon = container.querySelector('.js-pauseIcon');
        const playIcon = container.querySelector('.js-playIcon');
        const nav = container.querySelector('.autoplayElement__nav');
        const visual = container.querySelector('.autoplayElement__visual');
        const duration = parseInt(container.getAttribute('data-duration')) || 10000;

        let currentIndex = 0;
        let isPaused = false;
        let startTime = null;
        let remainingTime = duration;
        let animationFrame = null;
        let bodyHeights = [];

        // Misst die natürliche Höhe eines Body-Elements (auch wenn er aktuell height:0 hat)
        const measureBodyHeight = (body) => {
            const savedStyles = {
                height: body.style.height,
                maxHeight: body.style.maxHeight,
                position: body.style.position,
                visibility: body.style.visibility,
                opacity: body.style.opacity,
                width: body.style.width,
                transition: body.style.transition,
            };
            body.style.transition = 'none';
            body.style.height = 'auto';
            body.style.maxHeight = 'none';
            body.style.position = 'absolute';
            body.style.visibility = 'hidden';
            body.style.opacity = '0';
            // Breite beibehalten, damit Text-Umbrüche korrekt berechnet werden
            body.style.width = body.parentElement.offsetWidth + 'px';
            const h = body.scrollHeight;
            Object.assign(body.style, savedStyles);
            return h;
        };

        // Berechnet und setzt die feste Nav-Höhe anhand des längsten Textes
        const setNavHeight = () => {
            const bodies = Array.from(items).map(item => item.querySelector('.autoplayElement__body'));

            // Transitionen und Höhen deaktivieren für saubere Messung
            bodies.forEach(b => {
                b.style.transition = 'none';
                b.style.height = '0';
            });

            // Reflow erzwingen, damit height:0 gilt
            nav.offsetHeight;

            // Alle Body-Höhen messen — auch den längsten Text
            bodyHeights = bodies.map(body => measureBodyHeight(body));

            if (!bodyHeights.length) return;

            const maxBodyHeight = Math.max(...bodyHeights);

            // Summe aller Item-Höhen wenn Bodys geschlossen (= nur Header + Border)
            const totalItemsHeight = Array.from(items).reduce((sum, item) => sum + item.offsetHeight, 0);

            const navHeight = totalItemsHeight + maxBodyHeight;
            nav.style.height = navHeight + 'px';

            // Desktop: Visual bekommt dieselbe Höhe
            if (window.innerWidth >= 992) {
                visual.style.height = navHeight + 'px';
                visual.style.minHeight = '';
            } else {
                // Mobil: Visual hat eigene CSS-Höhe, nicht überschreiben
                visual.style.height = '';
                visual.style.minHeight = '';
            }

            // Transitionen wieder aktivieren (nach zwei Frames, damit kein Flash entsteht)
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    bodies.forEach(b => { b.style.transition = ''; });
                });
            });
        };

        const updateUI = (index) => {
            items.forEach((item, i) => {
                const body = item.querySelector('.autoplayElement__body');
                const bar = item.querySelector('.js-autoplayProgressBar');

                item.classList.toggle('active', i === index);

                if (i === index) {
                    body.style.height = (bodyHeights[i] || 0) + 'px';
                } else {
                    body.style.height = '0';
                    if (bar) {
                        bar.style.transition = 'none';
                        bar.style.width = '0';
                    }
                }
            });

            images.forEach((img, i) => {
                img.classList.toggle('active', i === index);
            });
        };

        const startProgress = (time) => {
            if (!startTime) startTime = time;
            const elapsed = time - startTime;
            const progress = Math.min((elapsed / duration) * 100, 100);

            const activeBar = items[currentIndex].querySelector('.js-autoplayProgressBar');
            if (activeBar) {
                activeBar.style.transition = 'none';
                activeBar.style.width = `${progress}%`;
            }

            if (elapsed < duration) {
                if (!isPaused) {
                    animationFrame = requestAnimationFrame(startProgress);
                }
            } else {
                next();
            }
        };

        const next = () => {
            cancelAnimationFrame(animationFrame);
            currentIndex = (currentIndex + 1) % items.length;
            startTime = null;
            updateUI(currentIndex);
            if (!isPaused) {
                animationFrame = requestAnimationFrame(startProgress);
            }
        };

        const goTo = (index) => {
            cancelAnimationFrame(animationFrame);
            currentIndex = index;
            startTime = null;
            updateUI(currentIndex);
            if (!isPaused) {
                animationFrame = requestAnimationFrame(startProgress);
            }
        };

        items.forEach((item, index) => {
            item.addEventListener('click', () => goTo(index));
        });

        pauseBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            isPaused = !isPaused;

            pauseIcon.classList.toggle('d-none', isPaused);
            playIcon.classList.toggle('d-none', !isPaused);

            if (isPaused) {
                cancelAnimationFrame(animationFrame);
                const now = performance.now();
                const elapsed = now - startTime;
                remainingTime = duration - elapsed;
            } else {
                const now = performance.now();
                startTime = now - (duration - remainingTime);
                animationFrame = requestAnimationFrame(startProgress);
            }
        });

        // Init: Höhe berechnen, dann ersten Item aktivieren (ohne Animation)
        setNavHeight();
        updateUI(currentIndex);
        animationFrame = requestAnimationFrame(startProgress);

        // Bei Resize neu berechnen (debounced)
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                setNavHeight();
                updateUI(currentIndex);
            }, 150);
        });
    });
});
